import { Injectable } from '@angular/core';
import { Mutex as AsyncMutex } from 'async-mutex';

@Injectable({ providedIn: 'root' })
export class Mutex {
  private mutex = new AsyncMutex();

  constructor() { }

  /**
   * Acquires the lock using async-mutex.
   * Resolves with a `release()` function that the caller must call when done.
   */
  async acquire(name: string | null = null): Promise<() => void> {
    if (name) {
      console.log(`Mutex acquired by: ${name}`);
    }
    const release = await this.mutex.acquire();
    const myRelease = () => {
      if (name) console.log(`Mutex released by: ${name}`);
      release();
    };
    return myRelease;
  }
}
